import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../api/client';
import { useSessionStore } from './session-store';

export interface CurrentUser {
  id: string;
  email: string;
  fullName: string;
  roleCodes: string[];
  totpEnabled: boolean;
  mustEnrollTotp: boolean;
}

/** Copied byte-for-byte from `apps/web-admin/src/auth/use-current-user.ts` — `roleCodes` is what `order-permissions.ts` needs to condition every write action by permission, not by role name. */
export function useCurrentUser() {
  const isAuthenticated = useSessionStore((state) => state.isAuthenticated());

  return useQuery({
    queryKey: ['me'],
    queryFn: () => apiRequest<CurrentUser>('/auth/me'),
    enabled: isAuthenticated,
  });
}
